import React from 'react';
import { CheckboxItem, ItemIndicator } from '@radix-ui/react-dropdown-menu';
import pt from 'prop-types';

import { classNames } from 'utils';

import Icon from 'components/icon';

export default class DropdownMenuCheckboxItem extends React.PureComponent {
  static propTypes = {
    children: pt.node.isRequired,
    className: pt.string,
  };

  render() {
    const { children, className } = this.props;

    return (
      <CheckboxItem
        {...this.props}
        className={classNames(
          'dropdown-menu-item dropdown-menu-checkbox-item',
          className,
        )}
      >
        <span className="dropdown-menu-item-indicator">
          <ItemIndicator>
            <Icon fa="check" />
          </ItemIndicator>
        </span>
        {children}
      </CheckboxItem>
    );
  }
}
